/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkDay } from '../../models/work-day';

export interface ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Params {
  companyId?: string;
}

export function apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkDay>>> {
  const rb = new RequestBuilder(rootUrl, apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkDay>>;
    })
  );
}

apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain.PATH = '/api/v0/workDay/getAllWorkingDaysByCompany';
